// @ts-nocheck
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const SSE_EVENTS = {
  NEED_NOTIFICATION_PAGE_REFRESH: 'need_notification_page_refresh',
  NEED_REPORT_PAGE_REFRESH: 'need_report_page_refresh',
  NEED_SYSTEM_TASK_PAGE_REFRESH: 'need_system_task_page_refresh',

  NEED_ENTITY_PAGE_REFRESH: 'need_entity_page_refresh',
  NEED_ENTITY_CHAT_PAGE_REFRESH: 'need_entity_chat_page_refresh',
  NEED_ENTITY_ATTRIBUTE_PAGE_REFRESH: 'need_entity_attribute_page_refresh',
  NEED_ARCHIVE_ENTITY_PAGE_REFRESH: 'need_archive_entity_page_refresh',
  NEED_FREEZE_ENTITY_PAGE_REFRESH: 'need_freeze_entity_page_refresh',
  NEED_DOCUMENT_PAGE_REFRESH: 'need_document_page_refresh',
  NEED_ATTRIBUTE_DOCUMENT_SSE: 'Document upload',
  DOC_ASSESS_RUN_UPDATED: 'doc_assess_run_updated',

  AUTOMATION_NOTIFICATION: 'automation_event_notification',
  DB_SYNC: 'ReportDB Sync',
  REGULATORY_MAPPING_NOTIFICATION: 'regulatory_mapping_notification',
  NEED_REGULATORY_MAPPING_PAGE_REFRESH: 'need_regulatory_mapping_page_refresh',
  REGULATORY_POLICY_UPDATED: 'regulatory_policy_updated',
  REGULATORY_RUN_UPDATED: 'regulatory_run_updated',
  AI_GOVERNANCE_DISCOVER: 'ai_governance_discovery',
};

export const COUNTER_EVENTS = new Set([
  SSE_EVENTS.NEED_NOTIFICATION_PAGE_REFRESH,
  SSE_EVENTS.NEED_REPORT_PAGE_REFRESH,
  SSE_EVENTS.NEED_SYSTEM_TASK_PAGE_REFRESH,
  SSE_EVENTS.NEED_REGULATORY_MAPPING_PAGE_REFRESH,
  SSE_EVENTS.REGULATORY_POLICY_UPDATED,
]);

export const ENTITY_EVENTS = new Set([
  SSE_EVENTS.NEED_ENTITY_PAGE_REFRESH,
  SSE_EVENTS.NEED_ENTITY_CHAT_PAGE_REFRESH,
  SSE_EVENTS.NEED_ENTITY_ATTRIBUTE_PAGE_REFRESH,
  SSE_EVENTS.NEED_ARCHIVE_ENTITY_PAGE_REFRESH,
  SSE_EVENTS.NEED_FREEZE_ENTITY_PAGE_REFRESH,
  SSE_EVENTS.NEED_DOCUMENT_PAGE_REFRESH,
  SSE_EVENTS.NEED_ATTRIBUTE_DOCUMENT_SSE,
  SSE_EVENTS.DOC_ASSESS_RUN_UPDATED,
]);

export const ENTITY_PAGE_REFRESH_EVENTS = new Set([
  SSE_EVENTS.AI_GOVERNANCE_DISCOVER,
  SSE_EVENTS.REGULATORY_RUN_UPDATED,
]);

export const DB = new Set([SSE_EVENTS.DB_SYNC]);

const initialState = {
  counterEvents: {
    [SSE_EVENTS.NEED_NOTIFICATION_PAGE_REFRESH]: 0,
    [SSE_EVENTS.NEED_REPORT_PAGE_REFRESH]: 0,
    [SSE_EVENTS.NEED_SYSTEM_TASK_PAGE_REFRESH]: 0,
    [SSE_EVENTS.NEED_REGULATORY_MAPPING_PAGE_REFRESH]: 0,
    [SSE_EVENTS.REGULATORY_POLICY_UPDATED]: 0,
  },
  entityEvents: {
    [SSE_EVENTS.NEED_ENTITY_PAGE_REFRESH]: {},
    [SSE_EVENTS.NEED_ENTITY_CHAT_PAGE_REFRESH]: {},
    [SSE_EVENTS.NEED_ENTITY_ATTRIBUTE_PAGE_REFRESH]: {},
    [SSE_EVENTS.NEED_ARCHIVE_ENTITY_PAGE_REFRESH]: {},
    [SSE_EVENTS.NEED_FREEZE_ENTITY_PAGE_REFRESH]: {},
    [SSE_EVENTS.NEED_DOCUMENT_PAGE_REFRESH]: {},
    [SSE_EVENTS.NEED_ATTRIBUTE_DOCUMENT_SSE]: {},
    [SSE_EVENTS.DOC_ASSESS_RUN_UPDATED]: {},
  },
  dbSyncEvents: {
    [SSE_EVENTS.DB_SYNC]: {},
  },
  entityPageRefresh: {
    [SSE_EVENTS.AI_GOVERNANCE_DISCOVER]: {},
    [SSE_EVENTS.REGULATORY_RUN_UPDATED]: {},
  },
};

const sseSlice = createSlice({
  name: 'sse',
  initialState,
  reducers: {
    /**
     * on receiving event, we will increase the counterEvents key value by 1,
     * but there is no use of this value
     * we will track the change in value, and will perform certain actions
     */
    bumpCounter(state, action) {
      state.counterEvents[action.payload] += 1;
    },

    // Show Notification with page refresh
    notificationAndPageRefreshEvent(state, action) {
      const { sseType, ...eventData } = action.payload;
      if (sseType) {
        state.entityPageRefresh[sseType] = { ...eventData };
      }
    },
    /**
     * for entityEvents we will need entity_id and entity_type to identify the entity,
     * so that we can perform action on that entity, whose entity_id & entity_type we have received through sse
     */
    addEntityEvent(state, action) {
      const { sseType, ...eventData } = action.payload;
      const entityId =
        eventData?.entity_id ??
        eventData?.events_data?.entity_id ??
        eventData?.data?.events_data?.entity_id ??
        eventData?.data?.entity_id;

      if (entityId !== undefined && entityId !== null) {
        if (!state.entityEvents[sseType]) {
          state.entityEvents[sseType] = {};
        }
        state.entityEvents[sseType][entityId] = { ...eventData };
      }
    },
    removeEntityEvent(state, action) {
      const { sseType, entityId } = action.payload || {};
      if (sseType && entityId && state.entityEvents[sseType]) {
        delete state.entityEvents[sseType][entityId];
      }
    },
    dbSyncEvent(state, action) {
      const { data, sseType } = action.payload;
      // Increment the counter to trigger component re-renders
      state.dbSyncEvents[sseType] = { data, sseType };
    },
  },
});

export const {
  bumpCounter,
  addEntityEvent,
  removeEntityEvent,
  dbSyncEvent,
  notificationAndPageRefreshEvent,
} = sseSlice.actions;
export default sseSlice.reducer;
